import { calculateReceiptPrices } from './calculatePrices'

const propsToCompare = ['priceGross', 'priceNet', 'vatPercent', 'description', 'bookkeepingAccountNo']

export const addPosition = (data, position) => {
  if (!position) return data

  const newPositions = [...data.positions, { ...position, isNew: true }]
  const { priceTotal, outstandingAmount, priceNet } = calculateReceiptPrices(newPositions, data)

  return {
    ...data,
    positions: newPositions,
    priceTotal,
    priceNet,
    outstandingAmount,
  }
}

export const changePosition = (data, position, index) => {
  if (!position) return data

  const newPositions = [...data.positions]
  const isPositionChanged = propsToCompare.some(prop => newPositions?.[index]?.[prop] !== position?.[prop])
  newPositions[index] = { ...position, isChanged: position?.isChanged || isPositionChanged }
  const { priceTotal, outstandingAmount, priceNet } = calculateReceiptPrices(newPositions, data)

  return {
    ...data,
    positions: newPositions,
    priceTotal,
    priceNet,
    outstandingAmount,
  }
}

export const replacePositions = (data, positions) => {
  const newPositions = (positions || []).map(position => ({ ...position }))
  const { priceTotal, outstandingAmount, priceNet } = calculateReceiptPrices(newPositions, data)

  return {
    ...data,
    positions: newPositions,
    priceTotal,
    priceNet,
    outstandingAmount,
  }
}

export const deletePosition = (data, index) => {
  if (index < 0) return data

  const newPositions = [...data.positions]
  newPositions.splice(index, 1)
  const { priceTotal, outstandingAmount, priceNet } = calculateReceiptPrices(newPositions, data)

  return {
    ...data,
    positions: newPositions,
    priceTotal,
    priceNet,
    outstandingAmount,
  }
}
